import { isArray, isString } from "lodash";

export default (target, domId, classNames) => {
  let node = document.getElementById(domId);

  const classArray = isArray(classNames) ? classNames : isString(classNames) ? classNames.split(" ") : [];

  if (!node) {
    node = document.createElement("div");
    node.id = domId;
    classArray.forEach(n => (n ? node.classList.add(n) : null));
    let targetNode = isString(target) ? document.getElementById(target) : target;
    if (targetNode) {
      targetNode.appendChild(node);
    } else {
      document.body.appendChild(node);
    }
    return node;
  }
  return null;
};
